import type { RootState } from '~/store/reducers';
import { Campaign, CampaignTab } from './types';

export const selectCampaignTab = (
  state: RootState
): CampaignTab | undefined => {
  return state.campaign.page;
};

export const selectCurrentCampaign = (
  state: RootState
): Campaign | undefined => {
  return state.campaign.campaign;
};

export const selectCampaignCounts = (
  state: RootState
): {
  scheduled: number;
  sent: number;
  draftsCount: number;
  approvalsCount: number;
} => {
  const { campaign } = state.campaign;
  return {
    scheduled: campaign?.scheduled ?? 0,
    sent: campaign?.sent ?? 0,
    draftsCount: campaign?.draftsCount ?? 0,
    approvalsCount: campaign?.approvalsCount ?? 0,
  };
};
